import {
  Component,
  Input,
  OnInit, Optional, Self
} from '@angular/core';
import * as _ from 'lodash';
import {ControlValueAccessor, FormControl, NgControl} from "@angular/forms";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'custom-attribute',
  templateUrl: './custom-attribute.component.html',
  styleUrls: ['./custom-attribute.component.scss'],
})
export class CustomAttributeComponent implements OnInit, ControlValueAccessor {

  @Input() attributesObj;

  attributeKeys: string[] = [];
  attribute;
  attributeOptions = {};
  val: Object = {};
  private propagateChange = (_: any) => { };

  constructor(@Optional() @Self() public controlDirective: NgControl) {
    controlDirective.valueAccessor = this;
  }

  ngOnInit() {
    this.attribute = this.attributesObj.reduce((acc, cur) => {
      if (cur.has_options) {
        this.attributeOptions[cur.name] = cur.options.getContent();
      }
      acc[cur.name] = cur;
      return acc;
    }, {});
    this.attributeKeys = Object.keys(this.attribute);
    this.controlDirective.control.setValidators([this.validate.bind(this)]);
    this.controlDirective.control.updateValueAndValidity();
  }

  dataChanged() {
    this.propagateChange(this.val);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    this.val = obj;
  }

  validate({ value }: FormControl) {
    if (!value) {
      return true;
    }
    for (let i = 0; i< this.attributeKeys.length; i++) {
      let k = this.attributeKeys[i];
      if (this.attribute[k].is_required) {
        if (!value[k]) {
          return {
            invalid: true,
            message: this.attribute[k].display + ' is required'
          };
        }
      }
    }
    return true;
  }
}
